import React from 'react';
import { useForm } from 'react-hook-form';
import { useUpdateAgentEmail } from '../apis';
import { grey } from 'sushiweb/tokens/color';
import Spinner from 'sushiweb/Spinner/Spinner';
import { Star } from '../../../UiKit/Star/Star';
import Button from '../../../components/ComponentsV1/Button';

function UpdateAgentEmail() {
  const form = useForm();
  const { register, handleSubmit, formState, reset } = form;
  const { errors } = formState;

  const { isLoading, mutate } = useUpdateAgentEmail({
    onSuccess: () => {
      reset();
    },
  });

  const onSubmit = (data) => {
    const dataToSubmit = {
      old_email: data.old_email,
      new_name: data.new_name,
      new_email: data.new_email,
      new_phone: `+91${data.new_phone}`,
      shell_phone: `+91${data.shell_phone}`,
    };
    mutate(dataToSubmit);
  };

  return (
    <form
      className='tw-w-full tw-flex tw-flex-col tw-h-max tw-gap-10 tw-bg-white tw-p-8 tw-rounded-2xl'
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className='tw-flex tw-w-full tw-h-max tw-gap-5'>
        <div className='tw-flex tw-flex-col tw-h-max tw-gap-1 tw-flex-1'>
          <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
            Current Email Id <Star icon='*' />
          </div>
          <div className='tw-flex tw-flex-col tw-w-full'>
            <input
              id='OldEmailId'
              name='old_email'
              type='email'
              placeholder='Enter current email id'
              className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px]
          ${
            errors?.old_email?.message
              ? 'focus:tw-ring-[#BF2938] focus:tw-border-RED'
              : 'focus:tw-ring-green-500 focus:tw-border-green-500'
          }  tw-border tw-border-solid tw-border-[#cfcfcf] tw-mr-6`}
              autoComplete='off'
              {...register('old_email', {
                pattern: {
                  value: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/,
                  message: 'Invalid email id',
                },
                required: {
                  value: true,
                  message: 'Current Email Id is Required',
                },
              })}
              data-dd-privacy='mask'
            />
            <p className='tw-mt-1 tw-text-[#BF2938]'>
              {errors?.old_email?.message}
            </p>
          </div>
        </div>
        <div className='tw-flex tw-flex-col tw-h-max tw-gap-1 tw-flex-1'>
          <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
            Current Mobile Number <Star icon='*' />
          </div>
          <div className='tw-flex tw-flex-col tw-w-full'>
            <input
              id='currentMobNo'
              name='new_phone'
              type=''
              placeholder='Enter current mobile number'
              className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px] tw-w-full
          ${
            errors.new_phone?.message
              ? 'focus:tw-ring-[#BF2938] focus:tw-border-RED'
              : 'focus:tw-ring-green-500 focus:tw-border-green-500'
          }  tw-border tw-border-solid tw-border-[#cfcfcf] tw-mr-6`}
              {...register('new_phone', {
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: 'Invalid Mobile Number ',
                },
                required: {
                  value: true,
                  message: 'Current Mobile Number is Required',
                },
              })}
              autoComplete='off'
              data-dd-privacy='mask'
            />
            <p className='tw-mt-1 tw-text-[#BF2938]'>
              {errors?.new_phone?.message}
            </p>
          </div>
        </div>
      </div>
      <div className='tw-flex tw-w-full tw-h-max tw-gap-5'>
        <div className='tw-flex tw-flex-col tw-h-max tw-gap-1 tw-flex-1'>
          <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
            Name
            <Star icon='*' />
          </div>
          <div className='tw-flex tw-flex-col tw-w-full'>
            <input
              id='name'
              name='new_name'
              type='text'
              placeholder='Enter agent name'
              className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px]
          ${
            errors?.new_name?.message
              ? 'focus:tw-ring-[#BF2938] focus:tw-border-RED'
              : 'focus:tw-ring-green-500 focus:tw-border-green-500'
          }  tw-border tw-border-solid tw-border-[#cfcfcf] tw-mr-6`}
              autoComplete='off'
              {...register('new_name', {
                required: { value: true, message: 'Name is Required' },
              })}
              data-dd-privacy='mask'
            />
            <p className='tw-mt-1 tw-text-[#BF2938]'>
              {errors?.new_name?.message}
            </p>
          </div>
        </div>
        <div className='tw-flex tw-flex-col tw-h-max tw-gap-1 tw-flex-1'>
          <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
            New Email Id <Star icon='*' />
          </div>
          <div className='tw-flex tw-flex-col tw-w-full'>
            <input
              id='NewemailId'
              name='new_email'
              placeholder='Enter new email id'
              className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px] tw-w-full
          ${
            errors.new_email?.message
              ? 'focus:tw-ring-[#BF2938] focus:tw-border-RED'
              : 'focus:tw-ring-green-500 focus:tw-border-green-500'
          }  tw-border tw-border-solid tw-border-[#cfcfcf] tw-mr-6`}
              {...register('new_email', {
                pattern: {
                  value: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/,
                  message: 'Invalid email id',
                },
                required: { value: true, message: 'New Email Id is Required' },
              })}
              autoComplete='off'
              data-dd-privacy='mask'
            />
            <p className='tw-mt-1 tw-text-[#BF2938]'>
              {errors?.new_email?.message}
            </p>
          </div>
        </div>
        <div className='tw-flex tw-flex-col tw-h-max tw-gap-1 tw-flex-1'>
          <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
            Dummy Mobile Number <Star icon='*' />
          </div>
          <div className='tw-flex tw-flex-col tw-w-full'>
            <input
              id='NewMobNo'
              name='shell_phone'
              type='number'
              placeholder='Enter a dummy mobile number'
              className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px] tw-w-full
          ${
            errors.shell_phone?.message
              ? 'focus:tw-ring-[#BF2938] focus:tw-border-RED'
              : 'focus:tw-ring-green-500 focus:tw-border-green-500'
          }  tw-border tw-border-solid tw-border-[#cfcfcf] tw-mr-6`}
              {...register('shell_phone', {
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: 'Invalid Mobile Number',
                },
                required: {
                  value: true,
                  message: 'Dummy Mobile Number is Required',
                },
              })}
              autoComplete='off'
              data-dd-privacy='mask'
            />
            <p className='tw-mt-1 tw-text-[#BF2938]'>
              {errors?.shell_phone?.message}
            </p>
          </div>
        </div>
      </div>
      <Button loading={isLoading} title={'Submit'} className={'tw-w-fit'} />
    </form>
  );
}

export default UpdateAgentEmail;
